import React from "react";
import { Dialog } from "primereact/dialog";

function PaymentModal({ setIsModalOpen, transactData }) {
  if (!transactData) return null;

  return (
    <Dialog
      visible={true}
      onHide={() => setIsModalOpen(false)}
      header="Transaction Summary"
      style={{ width: "450px", maxWidth: "95vw" }}
      dismissableMask
      draggable={false}
      resizable={false}
    >
      <div className="text-sm">
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Order ID:</span>
          <span>{transactData["Order Id"] || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Customer Name:</span>
          <span>{transactData.CustomerName || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Customer Email:</span>
          <span className="truncate max-w-[220px]" title={transactData.CustomerEmail}>
            {transactData.CustomerEmail || "-"}
          </span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Approval Code:</span>
          <span>{transactData["Approval Code"] || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Masked PAN:</span>
          <span>{transactData.PAN || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">RRN:</span>
          <span>{transactData.RRN || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Card Holder:</span>
          <span>{transactData["Card Holder"] || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Convenience Fee:</span>
          <span>{transactData["Convenience Fee"] || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Transaction Date:</span>
          <span>{transactData.TranTime || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b font-semibold">
          <span className="font-semibold text-gray-700">Transaction Amount:</span>
          <span>{transactData.Amount || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Description:</span>
          <span className="text-right">{transactData.Description || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Status:</span>
          <span className="font-semibold text-primary">{transactData.status || "-"}</span>
        </p>
        <p className="py-2.5 flex justify-between border-b">
          <span className="font-semibold text-gray-700">Status Description:</span>
          <span>{transactData.StatusDescription || "-"}</span>
        </p>
      </div>
    </Dialog>
  );
}

export default PaymentModal;
